import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "@/src/config/api.js";

const isYouTubeUrl = (url) => {
    if (!url) return false;
    return /youtube\.com|youtu\.be/i.test(url);
};

const PopularTracks = () => {
    const [tracks, setTracks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(API_ENDPOINTS.tracks.popularLastWeek)
            .then(response => response.json())
            .then(data => {
                setTracks(data.tracks);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching popular tracks:", error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="bg-neutral-900 rounded-lg p-4">
                <h2 className="font-bold text-lg mb-4">POPULAR TRACKS FROM LAST WEEK</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
                        <div key={i} className="animate-pulse">
                            <div className="aspect-square bg-neutral-800 rounded-lg mb-2"></div>
                            <div className="h-4 bg-neutral-800 rounded w-3/4 mb-2"></div>
                            <div className="h-3 bg-neutral-800 rounded w-1/2"></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="bg-neutral-900 rounded-lg p-4">
            <h2 className="font-bold text-lg mb-4">POPULAR TRACKS FROM LAST WEEK</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                {tracks.map((track) => (
                    <div key={track.id} className="group">
                        <a href={`/tracks/${track.id}`} className="block no-underline">
                            <div className="relative aspect-square mb-2 overflow-hidden rounded-lg">
                                <img
                                    src={isYouTubeUrl(track.sc_url)
                                        ? `https://i3.ytimg.com/vi/${track.media_id}/hqdefault.jpg`
                                        : `https://www.dreamchimney.com/tracks/track_images/${track.img_url}`}
                                    alt={`${track.artist} - ${track.title}`}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                            </div>
                            <h3 className="text-sm font-medium truncate group-hover:text-gray-300 transition-colors">
                                {track.artist} - {track.title}
                            </h3>
                            <div className="text-xs text-gray-400 mt-1">
                                {track.cnt} likes
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PopularTracks; 